<template>
  <div v-if="paymentProvider">
    <payment-provider-details
      :data-payment-provider.sync="paymentProvider"
      @update:dataPaymentProvider="updatePaymentProvider"
    />
    <cash-in-methods class="mt-3" :payment_provider_id="paymentProvider.id" />
  </div>
</template>

<script>
import CashInMethods from "../cashInMethods";
import PaymentProviderDetails from "./details";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: {
    CashInMethods,
    PaymentProviderDetails,
  },
  data: () => ({
    paymentProvider: null,
  }),
  mounted() {
    this.fetchPaymentProvider();
  },
  watch: {
    id() {
      this.fetchPaymentProvider();
    },
  },
  methods: {
    fetchPaymentProvider() {
      this.$http
        .get(`/api/v1/transactions/cryptoPaymentProviders/${this.id}`)
        .then((paymentProvider) => (this.paymentProvider = paymentProvider));
    },
    updatePaymentProvider(paymentProvider) {
      if (paymentProvider) {
        this.paymentProvider = paymentProvider;
      }
    },
  },
};
</script>

<style></style>
